import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

interface CarbonOffsetPriceParams extends FeeFactors {
  kilosCo2: number;
}

interface PercapitaParams {
  persons: number;
  months: number;
  years: number;
  days: number;
}

export const getCarbonOffsetPrice = (instance: AxiosInstance) => async (
  params: CarbonOffsetPriceParams,
  customerId: string,
  portfolioId?: string,
): Promise<OffsetPrice> => {
  const { data } = await instance.get<OffsetPrice>(`/customers/${customerId}/portfolios/co2/${portfolioId ?? 'default'}/price`, {
    params,
  });

  return data;
};

export const getPercapitaFootprint = (instance: AxiosInstance) => async (params: PercapitaParams, countryCode: string): Promise<PercapitaOffset> => {
  const { data } = await instance.get<PercapitaOffset>(`/footprint/percapita/pik/${countryCode}`, {
    params,
  });

  return data;
};

const handlers = {
  getCarbonOffsetPrice,
  getPercapitaFootprint,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createCarbonApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createCarbonApi;
